import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { useViewport } from '@sbt-web/hooks';
import { FilterURI } from '@sbt-web/network/types';
import { FormGroup, Toggle } from '@sbt-web/ui';
import type { RootState } from '@/reducers/index';
import { updateShippableOnly } from '@/reducers/search';
import { shippableOnlyLabel } from '@/tools/search/values';
import NationwideSearchExpander from '../../SearchNationwide';
import { FilterLabel } from '../common/FilterLabel';
import type { CommonFilterProps } from '../common/types';
import commonClasses from '../common/styles.module.scss';
import ownClasses from './shippable-only.module.scss';
type StateProps = {
  includeShippableOnly: boolean;
};
type DispatchProps = {
  updateShippableOnly: (includeShippableOnly: boolean) => void;
};
type OwnProps = {
  trackSearchConversion: () => void;
};
type Props = CommonFilterProps & StateProps & DispatchProps & OwnProps;
const ShippableOnlyComponent = t0 => {
  const $ = _c(15);
  const {
    includeShippableOnly,
    showBadgeNew,
    updateShippableOnly,
    trackSearchConversion
  } = t0;
  const {
    isMobile
  } = useViewport();
  let t1;
  if ($[0] !== trackSearchConversion || $[1] !== updateShippableOnly) {
    t1 = isSelected => {
      trackSearchConversion();
      updateShippableOnly(isSelected);
    };
    $[0] = trackSearchConversion;
    $[1] = updateShippableOnly;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSelection = t1;
  let t2;
  if ($[3] !== showBadgeNew) {
    t2 = <FilterLabel showBadgeNew={showBadgeNew}>Spedizione</FilterLabel>;
    $[3] = showBadgeNew;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [ownClasses["close-label"], commonClasses["custom-toggle"]];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleSelection || $[7] !== includeShippableOnly) {
    t4 = <Toggle name={FilterURI.ItemShippable} checked={includeShippableOnly} onInputChange={handleSelection} spaceBetweenElements={true} classes={t3}>{shippableOnlyLabel}</Toggle>;
    $[6] = handleSelection;
    $[7] = includeShippableOnly;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isMobile) {
    t5 = isMobile ? <NationwideSearchExpander id="filter-nationwide-search-expander" /> : null;
    $[9] = isMobile;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <FormGroup>{t2}{t4}{t5}</FormGroup>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const ShippableOnlySelector = connect<StateProps, DispatchProps, OwnProps, RootState>((state, ownProps) => ({
  includeShippableOnly: state.search.includeShippableOnly,
  trackSearchConversion: ownProps.trackSearchConversion
}), dispatch => ({
  updateShippableOnly: (isActive: boolean) => dispatch(updateShippableOnly(isActive))
}))(ShippableOnlyComponent);
export default ShippableOnlySelector;
export { ShippableOnlyComponent };